/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsCycle } from '../../models/submissions-cycle';
import { SubmissionsCycleUpdateIn } from '../../models/submissions-cycle-update-in';

export interface UpdateSubmissionsCycleInternalV2SubmissionsCycleIdPatch$Params {
  id: string;
  org: string;
      body: SubmissionsCycleUpdateIn
}

export function updateSubmissionsCycleInternalV2SubmissionsCycleIdPatch(http: HttpClient, rootUrl: string, params: UpdateSubmissionsCycleInternalV2SubmissionsCycleIdPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsCycle>> {
  const rb = new RequestBuilder(rootUrl, updateSubmissionsCycleInternalV2SubmissionsCycleIdPatch.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubmissionsCycle>;
    })
  );
}

updateSubmissionsCycleInternalV2SubmissionsCycleIdPatch.PATH = '/_internal/v2/submissions-cycle/{id}';
